<div class="mt-1 mb-3 flex align-items-center gap-5">
  <div class="align-items-center ml-auto flex gap-3">
    <label
      class="cursor-help"
      for="locked"
      tooltipPosition="top"
      pTooltip="gesperrte/freigegebene Indikatoren"
      [showDelay]="300"
      ><i class="fas fa-lock"></i
    ></label>
    <!-- NG21-MIGRATION(stufe-2): p-triStateCheckbox (2×) existiert seit PrimeNG 18 nicht mehr -> app-tri-state-checkbox (§8.4) -->
    <p-triStateCheckbox
      id="locked"
      (ngModelChange)="updateFilter()"
      [(ngModel)]="filterQuery.locked"
      inputId="locked" />
  </div>

  <div class="align-items-center flex gap-3">
    <label
      class="cursor-help"
      for="hasData"
      tooltipPosition="top"
      pTooltip="Indikatoren mit/ohne Daten"
      [showDelay]="300"
      ><i class="fas fa-database"></i
    ></label>
    <p-triStateCheckbox
      id="hasData"
      (onChange)="setHasDataFilter($event)"
      inputId="hasData" />
  </div>
  <div class="flex gap-3 align-items-center">
    <label for="category"><i class="fas fa-folder"></i></label>
    <p-treeSelect
      class="hide-icon-when-toggler-displayed"
      id="category"
      containerStyleClass="w-15rem"
      *ngIf="categoryStore.asTree() as categories"
      selectionMode="multiple"
      (onNodeSelect)="addCategoryToQuery($event)"
      (onNodeUnselect)="removeCategoryFromQuery($event)"
      [filter]="true"
      placeholder="Indikatorenordner"
      [options]="categories">
      <ng-template let-expanded pTemplate="itemtogglericon">
        <i
          class="tree-category-icon"
          [ngClass]="!expanded ? 'fas fa-folder' : 'fas fa-folder-open'"></i>
      </ng-template>
    </p-treeSelect>
  </div>
  <div class="flex gap-3 align-items-center">
    <label><i class="fas fa-tags"></i></label>
    <app-tag-filter-dropdown
      (selectedTagsChange)="updateFilter()"
      [(selectedTags)]="filterQuery.tags"></app-tag-filter-dropdown>
  </div>
  <div class="flex">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="fas fa-search" />
      <input
        class="w-15rem"
        pInputText
        placeholder="durchsuchen ..."
        [(ngModel)]="filterQuery.query"
        (ngModelChange)="updateFilter()" />
    </p-iconField>
  </div>
</div>
